<template>
  <div id="main-wrapper" :class="{'mini-sidebar': isMenuMinimized}">
    <!-- ============================================================== -->
    <!-- Topbar header - style you can find in pages.scss -->
    <!-- ============================================================== -->
    <navigation></navigation>
    <!-- ============================================================== -->
    <!-- Left Sidebar - style you can find in sidebar.scss  -->
    <!-- ============================================================== -->
    <sidebar></sidebar>
    <!-- ============================================================== -->
    <!-- End Left Sidebar - style you can find in sidebar.scss  -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- Page wrapper  -->
    <!-- ============================================================== -->
    <div class="page-wrapper">
      <notifications group="error" position="bottom right" />
      <notifications group="success" position="bottom right" />
        <!-- ============================================================== -->
        <!-- Container fluid  -->
        <!-- ============================================================== -->
            <!-- ============================================================== -->
            <!-- Start Page Content -->
            <!-- ============================================================== -->
            <router-view />
            <router-view name="modal"></router-view>
            <!-- ============================================================== -->
            <!-- End Start Page Content -->
            <!-- ============================================================== -->
            <!-- ============================================================== -->
            <!-- Right sidebar -->
            <!-- ============================================================== -->
            <right-sidebar></right-sidebar>
            <!-- ============================================================== -->
            <!-- End Right sidebar -->
            <!-- ============================================================== -->
        <!-- ============================================================== -->
        <!-- End Container fluid  -->
        <!-- ============================================================== -->
        <!-- ============================================================== -->
        <!-- footer -->
        <!-- ============================================================== -->
        <footer class="footer">
          © 2019 <span v-if="isWhiteLabel">Client Portal</span><span v-else>Nextlead Portal</span>
        </footer>
        <!-- ============================================================== -->
        <!-- End footer -->
        <!-- ============================================================== -->
    </div>
    <!-- ============================================================== -->
    <!-- End Page wrapper  -->
    <!-- ============================================================== -->
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Breadcrumb from '@/components/Breadcrumb';
import Navigation from '@/components/Navigation';
import RightSidebar from '@/components/RightSidebar';
import Sidebar from '@/components/Sidebar';

export default {
  components: {
    Breadcrumb,
    Navigation,
    RightSidebar,
    Sidebar,
  },
  computed: {
    ...mapState(['isMenuMinimized', 'isWhiteLabel']),
  },
};
</script>

<style>
.error-message {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  color: #f00;
}

dialog:not([open]) {
  display: none !important;
}

.footer {
  padding: 19px 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue